import { gql } from "graphql-request";
// GetEscalation
export const GetEscalation = gql`
    mutation ExecuteGetEscalation (
        $inScenarioID: UUID!
    ){
        executeGetEscalation(
            inScenarioID: $inScenarioID
        ) {
            AnnualEscalation
        }
    }
`;

// UpdateEscalation
export const UpdateEscalation = gql`
    mutation ExecuteUpdateEscalation (
        $inScenarioID: UUID!
        $inEscalation: String!
    ){
        executeUpdateEscalation(
            inScenarioID: $inScenarioID
            inEscalation: $inEscalation
        ) {
            result
        }
    }
`;
